import _ from 'lodash';
import { saveAs } from 'file-saver';
import XlsxPopulate from 'xlsx-populate';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

class Utils {
  static exportPDF(title, columns, rows, orientation) {
    const unit = 'pt';
    const size = 'A4';

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(14);

    const headers = [columns.map((column) => column.title)];

    const data = rows.map((row) => Object.values(_.omit(row, ['key'])));

    doc.text(title, marginLeft, 30, { maxWidth: 500, align: 'left' });
    doc.autoTable({
      startY: 50,
      head: headers,
      body: data,
      headStyles: {
        fontSize: 8,
        valign: 'bottom',
        halign: 'left',
        fillColor: '#426F80'
      },
      bodyStyles: {
        valign: 'bottom',
        halign: 'left',
        cellPadding: 4,
        minCellHeight: 35
      },
      theme: 'grid'
    });
    doc.save(title + '.pdf');
  }

  static getSheetData(data, header) {
    let fields = Object.keys(data[0]);
    let sheetData = data.map((row) => {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : '';
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }

  static async exportXLSX(titolo, header, rows, header2, rows2) {
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const columns = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U'
      ];
      const sheet1 = workbook.sheet(0).name('Dati');
      const sheetData = this.getSheetData(rows, header);
      const totalColumns = sheetData[0].length;

      let sheet2;
      let sheet2Data;
      if (header2 && rows2) {
        workbook.addSheet('Metadati');

        sheet2 = workbook.sheet(1);
        sheet2Data = this.getSheetData(rows2, header2);
        sheet2.cell('A1').value(sheet2Data);
        const range = sheet2.usedRange();
        const endColumn = String.fromCharCode(64 + sheet2Data[0].length);
        sheet2.row(1).style('bold', true);
        for (let i = 0; i < totalColumns; i++) {
          sheet2.column(columns[i]).width(sheet2Data[0].length > 10 ? 20 : 35);
        }
        sheet2.range('A1:' + endColumn + '1').style({
          fill: '426F80',
          fontColor: 'FFFFFF',
          horizontalAlignment: 'center',
          verticalAlignment: 'center',
          wrapText: true
        });
        sheet2.range('A2:' + endColumn + rows.length + 1).style({
          horizontalAlignment: 'left',
          verticalAlignment: 'bottom',
          wrapText: true
        });
        range.style('border', true);
      }

      sheet1.cell('A1').value(sheetData);
      const range = sheet1.usedRange();
      const endColumn = String.fromCharCode(64 + totalColumns);
      sheet1.row(1).style('bold', true);
      for (let i = 0; i < totalColumns; i++) {
        sheet1.column(columns[i]).width(totalColumns > 10 ? 20 : 35);
      }
      sheet1.range('A1:' + endColumn + '1').style({
        fill: '426F80',
        fontColor: 'FFFFFF',
        horizontalAlignment: 'center',
        verticalAlignment: 'center',
        wrapText: true
      });
      sheet1.range('A2:' + endColumn + rows.length + 1).style({
        horizontalAlignment: 'left',
        verticalAlignment: 'bottom',
        wrapText: true
      });
      range.style('border', true);
      return workbook.outputAsync().then((res) => {
        saveAs(res, titolo + '.xlsx');
      });
    });
  }

  static delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }
  
  static escapeDate(value) {
    if (value) {
        if (typeof (value) == 'string') {
            if (value.includes('999') && !value.includes('1999'))
                return "";

        }
        return value;
    }
    return "";
  }

  static getFileNameFromHeader(headersString) {
    const headersArray = headersString.split(';');
    let filename = "";
    headersArray.forEach(header => {
      if (header.includes('filename="')) {
        const name = header.split('filename="')[1];
        filename = name.substring(0, name.length - 1);
      }
    })

    if (filename === ""){
      headersArray.forEach(header => {
        if (header.includes('filename=') && !header.includes('filename=*')) {
          const name = header.split('filename=')[1];
          filename = name;
        }
      })
    }

    return filename;
  }

  static truncateEllipsis(text, truncateLength = 56) {
    return text.length > truncateLength ? text.substring(0, truncateLength) + "..." : text;
  }

  static customCapitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);

    //let rgx = /(^[\w])|( [\w])|(((?!(\w)).)(\w))/gmu;
    //return str.replace(rgx, (match, p1, p2, p3, offset, string) => {
    //  console.log({ match, p1, p2, p3, offset, string });
    //  return match.slice(0, -1) + match.slice(-1).toUpperCase();
    //});
  }
}

export default Utils;
